import { refreshShippingSelect } from './shippingSelect';

class ShippingResults {
    constructor(section) {
        this.section = section;
        this.form = section.querySelector('.search-box--form');
        this.btn = this.form.querySelector('.btn');
        this.fromCountry = this.form.querySelector('.from_country');
        this.toCountry = this.form.querySelector('.to_country');
        this.packageType = this.form.querySelector('.package_type');
        this.goodsWeight = section.querySelector('.goods_weight');
        this.tableSection = section.querySelector('.search-offers-table-wrapper');
        this.tableContainer = this.tableSection.querySelector('.grid-container');
        this.preloader = document.getElementById('preloader');
        this.header = document.querySelector('header.header');

        this.scrollPosition = 0;
        this.isDisabledScroll = false;
        this.isLoading = false;

        this.validation = {
            'fromCountry': null,
            'toCountry': null,
            'packageType': null,
            'goodsWeight': null,
            'isCountrySiteIdValid': null,
        };

        this.isValid = null;

        this.resetSelections();


        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.form.onchange = this.handleChange.bind(this);
    }
    
    disableScroll() {
        this.scrollPosition = window.scrollY;
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.classList.add('disable-scroll');
        this.isDisabledScroll = true;
    }

    enableScroll() {
        document.body.style.removeProperty('top');
        document.body.classList.remove('disable-scroll');
        window.scrollTo(0, this.scrollPosition);
        this.isDisabledScroll = false;
    }

    handleCountryChange(element) {
        const selectedOption = element.options[element.selectedIndex];
        const dataSrc = selectedOption.getAttribute("data-code-src");
        const countryFlag = element.closest('.country-select').querySelector('.countryFlag img');
        if (countryFlag) {
            countryFlag.setAttribute("src", dataSrc);
        }
    }

    changeWeightByType(type, dropdown) {
        const options = this.section.querySelectorAll('#item-options-hidden option');
        dropdown.innerHTML = '';
        options.forEach(option => {
            if (option.dataset.packageType === type) {
                let clone = option.cloneNode(true);
                dropdown.appendChild(clone);
            }
        });
        dropdown.selectedIndex = dropdown.options.length ? 0 : -1;
        refreshShippingSelect(dropdown);
    }

    successCallback(data) {
        this.tableSection.classList.add('active');
        this.tableContainer.innerHTML = data;
        this.preloader.style.display = 'none';
        this.enableScroll();
        this.tableSection.style.scrollMarginTop = `${this.header.offsetHeight}px`;
        this.tableSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    errorCallback(error) {
        console.error('Error:', error);
        this.preloader.style.display = 'none';
        this.enableScroll();
    }

    validateSelection(element, value) {
        const parentEl = element.closest('.qq-form--element');
        const errorMsg = parentEl.querySelector('.error');

        if (!value || value === '0') {
            errorMsg.classList.add('show');
            return false;
        }

        if (errorMsg.classList.contains('show')) {
            errorMsg.classList.remove('show');
        }

        return true;
    }

    validateCountrySiteId() {
        const error = this.form.querySelector('.error-country');

        if (this.fromCountry.value.toLowerCase() !== this.form.dataset.siteId.toLowerCase() && this.toCountry.value.toLowerCase() !== this.form.dataset.siteId.toLowerCase()) {
            error.classList.add('show');
            return false;
        }

        if (error.classList.contains('show')) {
            error.classList.remove('show');
        }

        return true;
    }

    updateIsValid() {
        this.isValid = Object.entries(this.validation).filter(([, value]) => value === false).length === 0;
        !this.isValid ? this.btn.setAttribute('disabled', 'disabled') : this.btn.removeAttribute('disabled', 'disabled');
    }

    handleSubmit(event) {
        event.preventDefault();

        this.validation.packageType = this.validateSelection(this.packageType, this.packageType.value);
        this.validation.goodsWeight = this.validateSelection(this.goodsWeight, this.goodsWeight.value);
        this.updateIsValid();

        if(!this.isValid) return;

        this.btn.setAttribute('disabled', 'disabled');
        this.preloader.style.display = 'flex';
        this.disableScroll();

        const formData = new URLSearchParams({
            action: 'sendify_search_results',
            nonce: themeVars.ajax_search_results_nonce,
            siteVersion: this.form.dataset.siteId,
            siteCurrency: this.form.dataset.siteCurrency,
            fromCountry: this.fromCountry.value,
            toCountry: this.toCountry.value,
            packageType: this.packageType.value,
            goodsWeight: this.goodsWeight.value,
            banner_bg: this.tableSection.dataset.formStyle,
            banner_text_color: this.tableSection.dataset.bannerText,
        });

        fetch(themeVars.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const contentType = response.headers.get("content-type");
                if (contentType.includes("application/json")) {
                    return response.json();
                } else if (contentType.includes("text/html")) {
                    return response.text();
                } else {
                    throw new Error("Response is not valid JSON or HTML");
                }
            })
            .then(this.successCallback.bind(this))
            .catch(this.errorCallback.bind(this));
    }

    handleChange({target}) {
        if (this.tableSection.classList.contains('active')) {
            this.tableSection.classList.remove('active');
        }

        if (target.classList.contains('from_country') || target.classList.contains('to_country')) {
            this.handleCountryChange(target);
            this.validation.fromCountry = this.validateSelection(this.fromCountry, this.fromCountry.value);
            this.validation.toCountry = this.validateSelection(this.toCountry, this.toCountry.value);
            this.validation.isCountrySiteIdValid = this.validateCountrySiteId();
        }

        if (target.classList.contains('package_type')) {
            const selectedOption = target.options[target.selectedIndex];
            const packageType = selectedOption.dataset.packageType.toLowerCase();
            this.changeWeightByType(packageType, this.goodsWeight);
            this.validation.packageType = this.validateSelection(this.packageType, this.packageType.value);
            this.validation.goodsWeight = this.validateSelection(this.goodsWeight, this.goodsWeight.value);
        }

        this.updateIsValid();

    }

    resetSelect(selectElement) {
        selectElement.selectedIndex = 0;
        refreshShippingSelect(selectElement);
        const event = new Event('change');
        selectElement.dispatchEvent(event);
    }

    resetSelections() {
        this.resetSelect(this.packageType);
        this.resetSelect(this.goodsWeight);
    }
}

export default ShippingResults;



// WEBPACK FOOTER //
// ./scripts/modules/shipping-results.js